// extracted by mini-css-extract-plugin
module.exports = {"separate":"AbonnementSeparate_separate__bIEsz","mobile":"AbonnementSeparate_mobile__3xUaH","favorite":"AbonnementSeparate_favorite__2zadB"};